import noimg from "../imgs/noimg.jpg"

const AddProduct = () => {
    const choosefile = () =>{
        document.getElementById("fileak").click();
    }
    return (
        <>
        <div className="container">
            <div className="addprd mt-5 container row">
                <div className="col-lg-6 col-md-12">
                    <label className="form-label"> Name Product <input type="text" className="form-control" /> </label>
                    <label className="form-label"> Description <textarea type="text" className="form-control" cols={100} rows={3} /> </label>
                    <label> Price
                        <div class="input-group">
                            <input type="text" class="form-control" aria-label="Dollar amount (with dot and two decimal places)" />
                            <span class="input-group-text" id="s2">$</span>
                            <span class="input-group-text" id="s2">0.00</span>
                        </div>
                    </label>
                </div>
                <div className="col-lg-6 col-md-12">
                    <input id="fileak" type="file" />
                    <label className="form-label">
                         Add images
                    </label>
                   <img src={noimg} /> <br/> <br/>
                   <button className="btn btn-primary" onClick={choosefile}> Add images </button>
                </div>
            
            </div>
            </div>    
            <div className="container">
                <button className="btn btn-primary mt-4"> Submit </button>
            </div>
        </>
    );
}

export default AddProduct;